import SellerBadgeList from './pages/SellerBadgeList.vue';

let Vue    = dokan_get_lib('Vue');
let Router = dokan_get_lib('Router');

Vue.use(Router);

const routes = [
    { path: '/', component: SellerBadgeList, name: 'SellerBadgeList' },
];

export default new Router({
    routes: routes
});
